import React from 'react'
import styles from './Modal.module.scss'
import closeIcon from './assets/close-icon.svg'
export default function Modal({children, handleClose, isOpen}: {children: React.ReactNode, handleClose?: () => void, isOpen?: boolean}) {
    
    if (!isOpen) {
        return <></>;
    }
  return (
    
    
    <div className={styles['modal']}>
       
        <div className={styles['modal__content']}>
        <div className={styles['header']}>
            <div className={styles['header__close']} onClick={handleClose}><img src={closeIcon} alt={'close'}/></div>
        </div>

        {children}
        </div>
    </div>
  )
}
